<template>
	<DaModalFrame v-model:open="modalIsOpen" @close="close">
		<UploadAvatar v-model:data="avatar" @upload="upload" @close="close" />
	</DaModalFrame>
	<input type="file" hidden id="upload-avatar-1" @change="uploadChange" />
	<div class="_information-table">
		<div
			class="_information-table__data __data bg-white rounded-2xl shadow-sm"
			v-if="editMode"
		>
			<div class="p-4 flex items-center justify-center flex-col">
				<img
					class="shadow-sm inline-block h-20 w-20 rounded-full"
					:src="staffData?.profile_photo?.w200"
					alt=""
					v-if="staffData?.profile_photo?.w200"
				/>
				<span
					v-else
					class="shadow-sm inline-flex items-center justify-center h-20 w-20 rounded-full text-white text-4xl"
					:style="{
						background: staffData.profile_photo?.default?.color,
					}"
				>
					<span class="font-medium leading-none text-white">{{
						staffData.profile_photo?.default?.initial
					}}</span>
				</span>
				<div
					class="mt-6 text-blue-700 font-semibold text-sm cursor-pointer"
					@click="openModelUpload"
				>
					Thay ảnh đại diện
				</div>
			</div>
			<div class="__data__header p-6 flex items-center justify-between">
				<div class="text-neutral-600 font-semibold">
					Thông tin cá nhân
				</div>
			</div>
			<div class="__data__content text-neutral-800">
				<div
					class="input-group flex-nowrap flex items-center px-6 py-4"
				>
					<div
						class="input-group__label w-56 text-neutral-500 font-normal"
					>
						Họ và tên
					</div>
					<div class="w-full">
						<input
							type="text"
							placeholder="Nhập họ và tên"
							v-model="staffData.full_name"
							:class="error['full_name'] ? 'input--error' : ''"
						/>
						<div
							class="error text-sienna-600 text-sm mt-2"
							v-if="error['full_name']"
						>
							{{ error['full_name'] }}
						</div>
					</div>
				</div>
				<div
					class="input-group flex-nowrap flex items-center px-6 py-4"
				>
					<div
						class="input-group__label w-56 text-neutral-500 font-normal"
					>
						Tên hiển thị
					</div>
					<div class="w-full">
						<input
							type="text"
							placeholder="Nhập tên hiển thị"
							v-model="staffData.name"
							:class="error['name'] ? 'input--error' : ''"
						/>
						<div
							class="error text-sienna-600 text-sm mt-2"
							v-if="error['name']"
						>
							{{ error['name'] }}
						</div>
					</div>
				</div>
				<div
					class="input-group flex items-center px-6 py-4 md-down:flex-col"
				>
					<div
						class="input-group__label text-neutral-500 font-normal w-56 md-down:w-full md-down:mb-4"
					>
						Ngày sinh
					</div>
					<div class="input-group w-full">
						<VueDatepicker
							class="input-date w-full"
							:placeholder="`Ngày sinh của ${$filters.terminology(
								'teacher_short_name'
							)}`"
							autoApply
							:enableTimePicker="false"
							uid="filter-by-date"
							format="dd/MM/yyyy"
							minutesIncrement="30"
							v-model="staffData.date_of_birth"
							:maxDate="new Date()"
						>
							<template #input-icon>
								<svg
									width="20"
									height="20"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M5 0.625C5 0.279822 4.72018 0 4.375 0C4.02982 0 3.75 0.279822 3.75 0.625V1.25H2.5C1.11929 1.25 0 2.36929 0 3.75V5H20V3.75C20 2.36929 18.8807 1.25 17.5 1.25H16.25V0.625C16.25 0.279822 15.9702 0 15.625 0C15.2798 0 15 0.279822 15 0.625V1.25H5V0.625ZM20 17.5V6.25H0V17.5C0 18.8807 1.11929 20 2.5 20H17.5C18.8807 20 20 18.8807 20 17.5ZM11.875 8.75C11.5298 8.75 11.25 9.02982 11.25 9.375V10.625C11.25 10.9702 11.5298 11.25 11.875 11.25H13.125C13.4702 11.25 13.75 10.9702 13.75 10.625V9.375C13.75 9.02982 13.4702 8.75 13.125 8.75H11.875ZM15.625 8.75C15.2798 8.75 15 9.02982 15 9.375V10.625C15 10.9702 15.2798 11.25 15.625 11.25H16.875C17.2202 11.25 17.5 10.9702 17.5 10.625V9.375C17.5 9.02982 17.2202 8.75 16.875 8.75H15.625ZM2.5 13.125C2.5 12.7798 2.77982 12.5 3.125 12.5H4.375C4.72018 12.5 5 12.7798 5 13.125V14.375C5 14.7202 4.72018 15 4.375 15H3.125C2.77982 15 2.5 14.7202 2.5 14.375V13.125ZM6.875 12.5C6.52982 12.5 6.25 12.7798 6.25 13.125V14.375C6.25 14.7202 6.52982 15 6.875 15H8.125C8.47018 15 8.75 14.7202 8.75 14.375V13.125C8.75 12.7798 8.47018 12.5 8.125 12.5H6.875Z"
										fill="#94A3B8"
									/>
								</svg>
							</template>
						</VueDatepicker>
					</div>
				</div>
				<div
					class="input-group flex-nowrap flex items-center px-6 py-4"
				>
					<div
						class="input-group__label w-56 text-neutral-500 font-normal"
					>
						SĐT cá nhân
					</div>
					<div class="w-full">
						<input
							type="text"
							placeholder="Nhập số điện thoại"
							v-model="staffData.phone_number"
							:class="error['phone_number'] ? 'input--error' : ''"
						/>
						<div
							class="error text-sienna-600 text-sm mt-2"
							v-if="error['phone_number']"
						>
							{{ error['phone_number'] }}
						</div>
					</div>
				</div>
				<div
					class="input-group flex-nowrap flex items-center px-6 py-4"
				>
					<div
						class="input-group__label w-56 text-neutral-500 font-normal"
					>
						SĐT khẩn cấp
					</div>
					<div class="w-full">
						<input
							type="text"
							placeholder="Nhập số điện thoại"
							v-model="staffData.emergency_phone_number"
							:class="
								error['emergency_phone_number']
									? 'input--error'
									: ''
							"
						/>
						<div
							class="error text-sienna-600 text-sm mt-2"
							v-if="error['emergency_phone_number']"
						>
							{{ error['emergency_phone_number'] }}
						</div>
					</div>
				</div>
				<div
					class="input-group flex-nowrap flex items-center px-6 py-4"
				>
					<div
						class="input-group__label w-56 text-neutral-500 font-normal"
					>
						Chức vụ
					</div>
					<div class="w-full">
						<select
							class="mt-1 block pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 rounded-md input w-full"
							v-model="staffData.role"
						>
							<option value="org_admin">Quản lý cơ sở</option>
							<option value="admin">Trưởng chuyên môn</option>
							<option value="teacher">
								{{ $filters.terminology('teacher') }}
							</option>
							<option value="accountant">Kế toán</option>
						</select>
					</div>
				</div>
				<div
					class="p-6 flex items-center justify-end border-t border-neutral-100"
				>
					<button
						type="button"
						class="button-p text-center w-32"
						@click="save"
					>
						Lưu chỉnh sửa
					</button>
				</div>
			</div>
		</div>
		<div
			class="_information-table__data __data bg-white rounded-2xl shadow-sm"
			v-else
		>
			<div class="__data__header p-6 flex items-center justify-between">
				<div class="text-neutral-600 font-semibold">
					Thông tin cá nhân
				</div>
				<DaIcon
					v-if="isAdmin"
					name="das--pen"
					class="h-5 w-5 cursor-pointer text-blue-600 hover:text-blue-900 active:text-blue-500"
					@click="changeEditMode"
				/>
			</div>
			<div class="__data__content text-neutral-800">
				<div class="p-4 flex items-center justify-center flex-col">
					<img
						class="shadow-sm inline-block h-20 w-20 rounded-full"
						:src="staffData?.profile_photo?.w200"
						alt=""
						v-if="staffData?.profile_photo?.w200"
					/>
					<span
						v-else
						class="shadow-sm inline-flex items-center justify-center h-20 w-20 rounded-full"
						:style="{
							background: staffData.profile_photo?.default?.color,
						}"
					>
						<span
							class="font-medium leading-none text-white text-4xl"
							>{{
								staffData.profile_photo?.default?.initial
							}}</span
						>
					</span>
					<div
						v-if="isUpload"
						class="mt-6 text-blue-700 font-semibold text-sm cursor-pointer"
						@click="openModelUpload"
					>
						Thay ảnh đại diện
					</div>
				</div>
				<div class="grid grid-cols-2 px-6 py-4 bg-neutral-50">
					<div class="text-neutral-500">Họ và tên</div>
					<div v-if="staffData.full_name">
						{{ staffData.full_name }}
					</div>
				</div>
				<div class="grid grid-cols-2 px-6 py-4">
					<div class="text-neutral-500">Tên hiển thị</div>
					<div v-if="staffData.name">{{ staffData.name }}</div>
				</div>
				<div class="grid grid-cols-2 px-6 py-4 bg-neutral-50">
					<div class="text-neutral-500">Ngày sinh</div>
					<div v-if="staffData.name">
						{{ $filters.formatDate2(staffData.date_of_birth) }}
					</div>
				</div>
				<div class="grid grid-cols-2 px-6 py-4">
					<div class="text-neutral-500">SĐT cá nhân</div>
					<div v-if="staffData.phone_number">
						{{ staffData.phone_number }}
					</div>
				</div>
				<div class="grid grid-cols-2 px-6 py-4 bg-neutral-50">
					<div class="text-neutral-500">SĐT khẩn cấp</div>
					<div v-if="staffData.phone_number">
						{{ staffData.emergency_phone_number }}
					</div>
				</div>
				<div class="grid grid-cols-2 px-6 py-4">
					<div class="text-neutral-500">Email</div>
					<div v-if="staffData.email" class="break-words">
						{{ staffData.email }}
					</div>
				</div>
				<div
					class="grid grid-cols-2 px-6 py-4 rounded-b-2xl bg-neutral-50"
				>
					<div class="text-neutral-500">Chức vụ</div>
					<div>{{ $filters.role(staffData.role) }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Options, Vue, setup } from 'vue-class-component';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import { Prop, Watch } from 'vue-property-decorator';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import UploadAvatar from '@/components/elements/uploadAvatar/UploadAvatar.vue';
import { $api } from '@/services';
import { useStore } from 'vuex';
import { isNumber } from '@/helper/DAValidate';
import heic2any from 'heic2any';

@Options({
	name: 'InformationTable',
	components: { UploadAvatar, DaModalFrame, DaIcon },
})
export default class InformationTable extends Vue {
	//----------------------- 🤍 Props 🤍 -----------------------//
	@Prop() staff;

	staffData = {
		full_name: '',
		id: 0,
		name: '',
		phone_number: '',
		emergency_phone_number: '',
		date_of_birth: '',
		role: '',
		state: '',
	};

	editMode = false;
	date = new Date();

	error = {
		name: '',
		full_name: '',
		status: false,
		phone_number: '',
		emergency_phone_number: '',
	};

	setup = setup(() => {
		const store = useStore();
		return {
			store,
		};
	});

	//----------------------- 🤍 Watch 🤍 -----------------------//
	@Watch('staff', { immediate: true, deep: true })
	onStaffChange(value) {
		this.staffData = value;
	}

	//----------------------- 🤍 Methods 🤍 -----------------------//
	get isUpload() {
		return this.setup.store.state.profile.staff.id === this.staffData.id;
	}

	get isAdmin() {
		return this.setup.store.getters.isAdmin;
	}

	changeEditMode() {
		this.editMode = true;
	}

	save() {
		this.error = {
			name: '',
			full_name: '',
			status: false,
			phone_number: '',
			emergency_phone_number: '',
		};
		if (this.staff.name?.length <= 0) {
			this.error['name'] = 'Tên hiển thị không được bỏ trống';
			this.error.status = true;
		}
		if (this.staff.full_name?.length <= 0) {
			this.error['full_name'] = 'Tên không được bỏ trống';
			this.error.status = true;
		}
		if (this.staff.phone_number && !isNumber(this.staff.phone_number)) {
			this.error['phone_number'] = 'Số điện thoại không hợp lệ';
			this.error.status = true;
		}
		if (this.error.status) {
			return;
		}
		this.editMode = false;
		this.$emit('submit', this.staffData);
	}

	modalIsOpen = false;
	avatar = '';

	openModelUpload() {
		const target = document.getElementById('upload-avatar-1');
		target ? target.click() : '';
	}

	uploadChange(event) {
		this.avatar = event.target.files[0];

		if (
			/image\/hei(c|f)/.test(event.target.files[0].type) ||
			event.target.files[0].name.endsWith('.heic') ||
			event.target.files[0].name.endsWith('.heif')
		) {
			heic2any({
				blob: event.target.files[0],
				toType: 'image/jpeg',
				quality: 1,
			}).then(async (jpgBlob) => {
				//Change the name of the file according to the new format
				let newName = event.target.files[0].name.replace(
					/\.[^/.]+$/,
					'.jpg'
				);

				//Convert blob back to file
				this.avatar = await this.blobToFile(jpgBlob, newName);

				this.modalIsOpen = true;
			});
		} else {
			this.modalIsOpen = true;
		}
	}

	blobToFile(theBlob, fileName) {
		//A Blob() is almost a File() - it's just missing the two properties below which we will add

		theBlob.name = fileName;

		//Cast to a File() type
		return new File([theBlob], fileName, {
			lastModified: new Date().getTime(),
			type: theBlob.type,
		});
	}

	close() {
		this.avatar = '';
		const target = document.getElementById('upload-avatar-1');
		target ? (target.value = null) : '';
		this.modalIsOpen = false;
	}

	upload(canvas) {
		canvas.toBlob(async (blob) => {
			let file = new File([blob], this.avatar.name, {
				type: blob.type,
			});
			let data = new FormData();
			data.append('profile_photo', file);
			const res = await $api.staff.uploadProfilePicture(data);
			if (res) {
				await this.setup.store.dispatch('setAlertMessage', {
					message: 'Cập nhật ảnh đại diện thành công',
				});
				this.close();
				this.$emit('updated');
			}
		});
	}
}
</script>
